export default __webpack_public_path__ + "static/media/languages.fa37c712.svg";